// extracted by mini-css-extract-plugin
module.exports = {"summary_tile_holder":"SummaryTilesHolder_summary_tile_holder__2sYQX","extraHeight":"SummaryTilesHolder_extraHeight__3kLSC"};